import { Component } from '@angular/core';
import { AvailabilityRoom1Component } from '../availability-room-1/availability-room-1.component';
import { LanguageService } from 'core-lib';
import { AvailabilityService } from 'core-lib';
import { SettingsService } from 'core-lib';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { AvailabilityRoom2RateComponent } from '../availability-room-2-rate/availability-room-2-rate.component';
import { ImageGallery1Component } from '../image-gallery1/image-gallery1.component';
import { AccordionModule } from 'primeng/accordion';
import { DisplayPricePipe } from '../../pipes/displayPrice';
import { formatRateNamePipe } from '../../pipes/format-rate-name.pipe';
import { TruncatedTextComponent } from '../truncated-text/truncated-text.component';

@Component({
    selector: 'app-availability-room-2',
    imports: [ DisplayPricePipe, AvailabilityRoom2RateComponent, ImageGallery1Component, ButtonModule, TranslateModule, AccordionModule, formatRateNamePipe, TruncatedTextComponent],
    templateUrl: './availability-room-2.component.html',
    styleUrl: './availability-room-2.component.scss'
})
export class AvailabilityRoom2Component extends AvailabilityRoom1Component {

  constructor(public override settings:SettingsService,  public override avService: AvailabilityService, public override languageService: LanguageService) {
    super(settings, avService, languageService);
  }

}
